module.exports = __webpack_public_path__ + "img/sup_deposit_crypto10.cb948f70.jpg";